import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

// Dropdown con un check por categoría. Se queda abierto mientras se marcan varias.
// No usa <Field> (un <label>): un clic dentro del panel activaría el botón disparador.
export default function CategoryMultiSelect({ options, selected, onToggle, disabled = false, testId = "kpi-editor-category" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);
  const summary = selected.length <= 2 ? selected.join(", ") : `${selected.length} categorías`;
  return (
    <div ref={ref} className="relative">
      <button type="button" onClick={() => setOpen((o) => !o)} disabled={disabled}
        className="input-field w-full flex items-center justify-between gap-2 text-left disabled:opacity-60 disabled:cursor-not-allowed"
        aria-haspopup="listbox" aria-expanded={open} data-testid={testId}>
        <span className="truncate">{summary}</span>
        <ChevronDown size={14} className={`shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && !disabled && (
        <div role="listbox" aria-multiselectable="true"
          className="absolute z-10 mt-1 w-full max-h-64 overflow-y-auto bg-white border border-[var(--line)] rounded-lg shadow-lg py-1">
          {options.map((c) => (
            <label key={c}
              className={`flex items-center gap-2 px-3 py-1.5 text-sm cursor-pointer hover:bg-[var(--cream-soft)] ${c === "Todas" ? "border-b border-[var(--line)] font-semibold" : ""}`}>
              <input type="checkbox" checked={selected.includes(c)} onChange={() => onToggle(c)}
                className="accent-[var(--lala-blue)] w-4 h-4" data-testid={`${testId}-option-${c}`} />
              {c}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
